import { axiosClient } from "../axios";

export function getAll() {
  return axiosClient.get("organizations");
}
